/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{PredicateError as e}from"./predicateerror.js";export const keyToEnum=(e,r)=>{if("object"!=typeof r)throw new Error("Invalid enum type");for(const o of Object.keys(r))if(e===o)return r[o];throw new Error("Invalid enum key")};export const isEnumType=(r,o,t=!1)=>{const n=Object.values(o).includes(r);return n||e.expected(t,void 0,"value from enum"),n};export const makeEnumTypePredicate=e=>(r,o=!1)=>isEnumType(r,e,o);